<template>
    <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex items-start px-4 py-6 sm:p-6">
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
            <transition
                enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div
                    v-if="show"
                    class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-dark-400 shadow-lg ring-1 ring-black ring-opacity-5"
                >
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="flex-shrink-0">
                                <div class="mt-0.5">
                                    <svg
                                        v-if="type === 'success'"
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <svg
                                        v-else-if="type === 'error'"
                                        class="h-6 w-6 text-red-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <div class="ml-3 w-0 flex-1">
                                <p v-if="message" class="text-base font-medium text-secondaryText dark:text-dark-100">
                                    {{ message }}
                                </p>
                                <p v-if="detail" class="mt-1 text-sm text-gray-500 dark:text-gray-300">{{ detail }}</p>
                            </div>
                            <div class="ml-4 flex flex-shrink-0">
                                <button
                                    type="button"
                                    class="inline-flex h-5 w-5 items-center justify-center rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0 focus:bg-gray-100"
                                    @click="hideNotification"
                                >
                                    <span class="sr-only">Close</span>
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            type: null,
            message: null,
            detail: null,
        };
    },
    methods: {
        showNotification(type, message, detail = null) {
            this.type = type;
            this.message = message;
            this.detail = detail;

            this.show = true;

            setTimeout(() => {
                this.hideNotification();
            }, 5000);
        },
        hideNotification() {
            this.show = false;

            this.type = null;
            this.message = null;
            this.detail = null;
        },
    },
};
</script>
